module.exports = __webpack_public_path__ + "static/media/information-icon-blue.f4cadb77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/information-icon-blue.svg
// module id = 274
// module chunks = 0